import type { DogOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/pet';
import type { CoverableOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { calculateAge, convertDateToLocalDateDTO } from '../../../utils/dateUtil';

interface HeaderProps {
    headerText: string;
    subHeaderText?: string;
}

const getCoveragePackageHeader = (coverable: CoverableOnsaDTO): HeaderProps | undefined => {
    switch (coverable.flavourName) {
        case 'Hundeforsikring': {
            const dog = coverable as DogOnsaDTO;
            if (calculateAge(dog?.dateOfBirth ?? convertDateToLocalDateDTO(new Date())) >= 7) {
                return {
                    headerText: 'DSS-PET-COVERABLE-PACKAGE-PAGE-ONE-PACKAGE-TITLE',
                    subHeaderText: 'DSS-PET-COVERABLE-PACKAGE-PAGE-7-YEARS-DOG'
                };
            } else if (dog?.dogUseId === 'Police') {
                return {
                    headerText: 'DSS-PET-COVERABLE-PACKAGE-PAGE-ONE-PACKAGE-TITLE',
                    subHeaderText: 'DSS-PET-COVERABLE-PACKAGE-PAGE-POLICE-DOG'
                };
            }
            break;
        }
        case 'Katteforsikring':
        case 'Børneforsikring':
        case 'Ulykkesforsikring til unge':
        case 'Ulykkesforsikring':
        default:
            return undefined;
    }
};

export default getCoveragePackageHeader;
